import { Navigate } from '@tanstack/react-router';
import { GP, useGaragePath } from '../lib/paths.js';

/**
 * Ancienne adresse « Chiffres » (02/10/2026) : décision du porteur du 03/10/2026, les chiffres rejoignent
 * l'espace « Gestion » (onglet Volume financier). L'adresse est gardée (favoris, liens) et redirige.
 */
export default function FiguresPage() {
  const gp = useGaragePath();
  return <Navigate to={gp(GP.gestionTab('finances'))} replace />;
}
